export interface PreQuoteView<T> {
  result: T | null;
  loading: boolean;
  error: Error | null;
}

/**
 * Render-time view of a pre-quote: never serve a result whose key is not the
 * current request identity (covers the frame before the effect runs).
 */
export function resolvePreQuoteDisplay<T>(
  key: string | null,
  held: PreQuoteView<T> & { key: string | null },
  cached: T | undefined
): PreQuoteView<T> {
  if (held.key === key) {
    return {
      result: held.result,
      loading: held.loading,
      error: held.error,
    };
  }
  if (!key) {
    return { result: null, loading: false, error: null };
  }
  if (cached) {
    return { result: cached, loading: false, error: null };
  }
  return { result: null, loading: true, error: null };
}
